// extracted by mini-css-extract-plugin
export default {"ellipsis":"edI6o87uJMRjCENqA1EU","wrapper":"mDsE2NJh0X8UK0VuHWr_","spin":"W5UFW3aHLxRhdI9KBBSZ"};